import { createAction } from 'typesafe-actions'
import { MenuBoardsActionTypes, SetSurroundingMenuBoards } from './types'

export const setSurroundingMenuBoards = createAction(
    MenuBoardsActionTypes.SET_SURROUNDING,
)<SetSurroundingMenuBoards>()
